import { AspectRatio, AspectRatioProps, Box, Image } from "@chakra-ui/react";
import TraitImage, { TraitImageProps } from "components/TraitImage";
import { publicUrl } from "config";
import { traitCategories } from "config/categories";
import { ImageSize } from "types";

export type TraitsCanvasProps = {
  traits: number[];
  imagesSize?: ImageSize;
  withV2Badge?: boolean;
} & Omit<AspectRatioProps, "ratio">;

const TraitsCanvas = ({
  traits,
  imagesSize = "512",
  withV2Badge = false,
  ...rest
}: TraitsCanvasProps) => {
  const defaultProps: Omit<TraitImageProps, "tokenId"> = {
    size: imagesSize,
    position: "absolute",
    top: "0",
    left: "0",
    w: "full",
  };

  return (
    <AspectRatio
      ratio={1}
      w="full"
      borderRadius="lg"
      overflow="hidden"
      {...rest}
    >
      <Box
        userSelect="none"
        pointerEvents="none"
        w="full"
        bg="dark.500"
        borderRadius="lg"
        {...rest}
      >
        <Image src={`${publicUrl}/v2-placeholder_transparent.png`} />

        {traitCategories.map((category, index) => (
          <TraitImage
            key={category}
            tokenId={traits[index]}
            {...defaultProps}
          />
        ))}

        {withV2Badge && (
          <Image
            src={`${publicUrl}/v2-badge.png`}
            fit="cover"
            {...defaultProps}
          />
        )}
      </Box>
    </AspectRatio>
  );
};

export default TraitsCanvas;
